import { ProductImage } from "scrivito/Objs/Product/Components/ProductImage"
import { ProductObj } from "scrivito/Objs/Product/ProductObjClass"

import { useExternalDimensioningModelAvailability } from "entities/products/model/useExternalDimensioningModelAvailability"
import { useProductConfigurationModelAvailability } from "entities/products/model/useProductConfigurationModelAvailability"

import { ProductCardProps } from "../ProductCard"

interface UseProductCardModelArgs {
  productObj: ProductObj
}

export function useProductCardModel({
  productObj
}: UseProductCardModelArgs): ProductCardProps {
  const productType = productObj.get("productType")
  const {
    isConfigurationAvailable,
    isLoading: isLoadingConfigurationAvailability
  } = useProductConfigurationModelAvailability(productType)
  const {
    isExternalDimensioningAvailable,
    isLoading: isLoadingExternalDimensoningAvailability
  } = useExternalDimensioningModelAvailability(productType)

  const isLoadingModels =
    isLoadingConfigurationAvailability ||
    isLoadingExternalDimensoningAvailability

  return {
    image: <ProductImage obj={productObj} />,
    product: productObj,
    hasPrice: isConfigurationAvailable,
    hasConfigurationModel: isConfigurationAvailable,
    hasExternalDimensioningModel: isExternalDimensioningAvailable,

    isLoading: isLoadingModels
  }
}
